import type { BadgeProps, SystemStyleObject } from "@chakra-ui/react";
import type { TTaskSystemPriority } from "@components/modules/resource-planning/tasks/components/task-priority-button/types";
import { TaskSystemPriorityEnum } from "@src/__generated__/graphql";

export const PRIORITY_BAR_COLORS: Record<
  TTaskSystemPriority,
  SystemStyleObject
> = {
  [TaskSystemPriorityEnum.Low]: {
    "--bar-1": "var(--chakra-colors-blue-500)",
    "--bar-2": "var(--chakra-colors-gray-200)",
    "--bar-3": "var(--chakra-colors-gray-200)",
  },
  [TaskSystemPriorityEnum.Medium]: {
    "--bar-1": "var(--chakra-colors-yellow-500)",
    "--bar-2": "var(--chakra-colors-yellow-500)",
    "--bar-3": "var(--chakra-colors-gray-200)",
  },
  [TaskSystemPriorityEnum.High]: {
    "--bar-1": "var(--chakra-colors-orange-500)",
    "--bar-2": "var(--chakra-colors-orange-500)",
    "--bar-3": "var(--chakra-colors-orange-500)",
  },
  [TaskSystemPriorityEnum.Urgent]: {
    color: "var(--chakra-colors-red-500)",
  },
};

/** Custom priority without a system level, drawn as the striped bars. */
export const CUSTOM_PRIORITY_BAR_COLORS: SystemStyleObject = {
  "--bar-1": "var(--chakra-colors-violet-500)",
  "--bar-2": "var(--chakra-colors-violet-500)",
  "--bar-3": "var(--chakra-colors-violet-500)",
  "--bar-stripe": "var(--chakra-colors-violet-500)",
};

export const PRIORITY_COLOR_SCHEME: Record<
  TTaskSystemPriority,
  BadgeProps["colorScheme"]
> = {
  [TaskSystemPriorityEnum.Low]: "blue",
  [TaskSystemPriorityEnum.Medium]: "yellow",
  [TaskSystemPriorityEnum.High]: "orange",
  [TaskSystemPriorityEnum.Urgent]: "red",
};

export const CUSTOM_PRIORITY_COLOR_SCHEME: BadgeProps["colorScheme"] = "violet";
